import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { canAccessRoute } from '@/utils/permissions'
import type { NavigationItem } from '@/types/auth'
import { getNavigationItems } from '@/router/routes'

export function useNavigation() {
  const authStore = useAuthStore()

  const navigationConfig: NavigationItem[] = getNavigationItems()

  const isNavigationItemAccessible = (item: NavigationItem): boolean => {
    if (!authStore.isAuthenticated) return false

    const routeMeta = { roles: item.roles }
    return canAccessRoute(authStore.user, routeMeta)
  }

  const availableNavigationItems = computed(() => {
    return navigationConfig
      .map((item) => ({
        ...item,
        children: item.children?.filter(isNavigationItemAccessible),
      }))
      .filter((item) => {
        if (item.children?.length) return item.children.length > 0
        return isNavigationItemAccessible(item)
      })
  })

  return {
    availableNavigationItems,
    isNavigationItemAccessible,
  }
}
